import { Fragment, useCallback, useEffect, useMemo, useState } from 'react'
import ApplicationCooDashboardLayout from '../layout/application-coo-dashboard-layout';
import { Separator } from '../components/separator';
import { P2Alert, P2EServiceCard, P2Modal } from 'react-bootstrap-common-script';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { StatusTrackers } from '../components/status-tracker';
import TrackerItem from '../components/status-tracker/tracker-item/tracker-item';
import { useAppDispatch, useAppSelector } from '../redux/hook';
import { Helpers } from '../utils/helper';
import useGetDashboardAlert from '../hooks/use-get-dashboard-alert';
import { updateProperties } from '../redux/slices/genuine-polymer-slice';
import useCheckHdbProperties from '../hooks/use-check-hdb-properties';
import { ApplicationStart } from '../models/classes/ApplicationStart.class';
import { updateApplicationStartFormDataThunk } from '../redux/slices/application-start-slice';
import { openRouteAddressSelection, openRouteStageD, openRouteStageE, openRouteStartCooApplication } from '../redux/slices/routes-management-slice';
import { resetStageDStates } from '../redux/slices/application-stage-d-slice';
import useCheckSmdByHdbRef from '../hooks/use-check-sms-by-hdb-ref';
import { setShowApplicationCancelled } from '../redux/slices/application-cancelled-slice';
import { API_ApplicationCreditNotification, API_ApplicationPayment, API_ApplicationProcessPayment, API_ApplicationRemove, API_ApplicationSaveDraft, API_ApplicationSubmit, API_EligibilityDebugLog, API_GiveConsent, API_SaveSingpassName, API_ValuationFeePending } from '../utils/api';
import { PolymerAxios } from '../utils/axios';
import { setActiveApplications } from '../redux/slices/active-applications-slice';
import config from '../config';
import { uniq } from 'lodash';
import { Properties } from '../models/polymer/Properties.model';
import { LottieLoader } from '../components/loader';
import { updateBb13Applications } from '../redux/slices/bb13-applications-slice';
import useGetBB13ApplicationsByHDBRefs from '../hooks/use-get-bb13-application';
import moment from 'moment';
import useIsMobile from '../hooks/use-is-mobile';
import FlatIcon from '../assets/svg/flat-icon';
import { resetAuthData, resetLocalStorage } from '../redux/slices/authentication-slice';

// import { ApplicationStatusEnum } from '../models/enum/application-status.enum'
function Root() {

  let [searchParams] = useSearchParams();

  const AppDispatch = useAppDispatch();
  let navigate = useNavigate(); 

  const [isCleared, setCleared] = useState<boolean>(false);
  const [ isInit, setIsInit ] = useState<boolean>(false);

  const { originalLoginUser } = useAppSelector(state => state.auth?.AuthenticationSlice || { originalLoginUser: {} });
  const loginUserSpcpName = useAppSelector((state) => state.auth?.AuthenticationSlice?.spcpName || "");
  const { HdbPropertyData, hasMultipleAddress, singleProperty, noProperty, isIncluded, isLoading: isRdbLoading, isError: isRdbError } = useCheckHdbProperties(originalLoginUser.uinfin, "A");
  const { smsInfo, isLoading, isError, hasOutstandingFees, mamsEligibilityData, hasInitiatedApplication, isTopupGrantRequired } = useCheckSmdByHdbRef(singleProperty ? singleProperty?.hdb_ref : "", "A");
  const [ continueDraftConfirmation, setContinueDraftConfirmation ] = useState<boolean>(false);
  const { ongoingApplications, alertJSX } = useGetDashboardAlert(smsInfo);  
  const startApplicationFormData = useAppSelector(state => state.app.ApplicationStartSlice.formData);
  const showApplicationCancelledAlert = useAppSelector(state => state.app.ApplicationCancelledSlice.show_application_cancelled_alert);
  const existingBb13Applications = useAppSelector(state => state.app.Bb13ApplicationsSlice.bb13Applications);
  const singpassToken = useAppSelector(state => state.auth?.AuthenticationSlice?.singpassToken || "");
  const [isMount, setIsMount] = useState(false);
  const [ hasOutstandingFeesModal, setHasOutstandingFeesModal ] = useState<boolean>(false);
  const [ hasApplicationInitiatedModal, setHasApplicationInitiatedModal ] = useState<boolean>(false);
  const [ hasClickInitiateButtonWhenApiLoading, setHasClickInitiateButtonWhenApiLoading ] = useState<boolean>(false);
  const [ hasTUGEligibilityModal, setHasTUGEligibilityModal ] = useState<boolean>(false);
  const [ hasSERSPostalCodeType1Modal, setHasSERSPostalCodeType1Modal ] = useState<boolean>(false);
  const [ hasSERSPostalCodeType2Modal, setHasSERSPostalCodeType2Modal ] = useState<boolean>(false);
  
  const [ onlyExistingPop, setOnlyExistingPop] = useState<boolean>(false);
  const [ isShowingOngoingTransactionModal, setIsShowingOngoingTransactionModal ] = useState<boolean>(false);

  const { isMobile } = useIsMobile();
  const isR2_151_Block_enabled = true; // R2-151: Block applications for specific postal codes due to the announcement of SERS

  const activeApplications = useMemo(() => {
    const nonEligibleStatuses = ["APPLICATION_APPROVED", "APPLICATION_COMPLETED", "APPLICATION_REJECTED", "APPLICATION_CANCELLED", "ARCHIVED", "CANCELLED", "REJECTED", "CLOSED", "PREPARE_FOR_COMPLETION_COMPLETE"];
    const filteredOngoingApplications = ongoingApplications?.filter(item => !nonEligibleStatuses.includes(item.application_status)) ?? [];
    return filteredOngoingApplications;
  }, [ongoingApplications])

  useEffect(() => {
    if(ongoingApplications && ongoingApplications.length > 0){
      const name = loginUserSpcpName === "" ? originalLoginUser?.name : loginUserSpcpName;
      const applicationlist = ongoingApplications.map(application => application.application_id);
      let saveSingpassNamePayload = {
        "application_id_list": applicationlist,
        "singpass_name": name
      }
      PolymerAxios(originalLoginUser?.uinfin ?? "", singpassToken).post(API_SaveSingpassName, saveSingpassNamePayload);
    }
  }, [ongoingApplications]);

  
  const stageDEActiveApplications = useMemo(() => {
    //status below getting from stages-process.tsx
    const stageDandEStatus = ["SENT_TO_BIOME", "PENDING_APPLICANT_HDB_REVIEW", "HDB_REVIEW", "APPROVE", "PENDING_BOOKING_APPOINTMENT", "REVIEW_FINANCIAL_PLAN", "PREPARE_FOR_COMPLETION"];    
    const filteredActiveApplications = activeApplications?.filter(item => stageDandEStatus.includes(item.application_status)) ?? [];
    return filteredActiveApplications;
  }, [activeApplications])

  const hdbRefList = uniq(HdbPropertyData?.map((item)=> item.hdb_ref));
  
  let { applicationsData: bb13Applications } = useGetBB13ApplicationsByHDBRefs(hdbRefList, activeApplications);
  
  useEffect(() => {
    if(bb13Applications !== undefined){
      AppDispatch(updateBb13Applications(bb13Applications));
    }
  }, [bb13Applications])

  const [valuationFeePendingApp, setValuationFeePendingApp] = useState<{ applicationUuid: string } | null>(null);

  useEffect(() => {
    if (!stageDEActiveApplications || stageDEActiveApplications.length === 0) {
      setValuationFeePendingApp(null);
      return;
    }
    let cancelled = false;
    (async () => {
      for (const app of stageDEActiveApplications) {
        if (cancelled) break;
        try {
          const res = await PolymerAxios(originalLoginUser?.uinfin ?? '', singpassToken).get(
            `${API_ValuationFeePending}?application_uuid=${encodeURIComponent(app.application_id)}`
          );
          const data = res.data;
          if (data && (data.status === 'PENDING' || data.status === 'SUBMIT_COMPLETE') && Number(data.valuation_fee) > 0) {
            if (!cancelled) setValuationFeePendingApp({ applicationUuid: app.application_id });
            return;
          }
        } catch {
          // no pending fee for this application
        }
      }
      if (!cancelled) setValuationFeePendingApp(null);
    })();
    return () => { cancelled = true; };
  }, [stageDEActiveApplications, originalLoginUser?.uinfin, singpassToken]);

  useEffect(() => {
    setIsMount(true);
  }, []);

  useEffect(() => {
    if(isMount) {
      return () => {AppDispatch(setShowApplicationCancelled(false))}
    }
  }, [isMount])

  const clearDataAndRoute = useCallback(() =>{
    //RESET
    Helpers.clearPersistData();
    AppDispatch(openRouteStartCooApplication(false));

    //Reset Stage D
    AppDispatch(openRouteStageD(false));
    AppDispatch(resetStageDStates());
    
    //Reset Stage E
    AppDispatch(openRouteStageE(false));
    setCleared(true);
  },[AppDispatch]);
  
  const toPath = useCallback((path:string) =>{ 
    navigate(path);
  },[navigate])

 
  useEffect(()=>{
    if(!isCleared){
      clearDataAndRoute();
    }
  },[clearDataAndRoute,isCleared])

  /**
   * Dispatch HDB Properties State from API.
   */
  useEffect(() => {
    if (isCleared && HdbPropertyData) {
      AppDispatch(updateProperties(HdbPropertyData));
    }
  }, [HdbPropertyData, AppDispatch, isCleared])

  /**
   * DO NOT REMOVE;
   * NOTE: This use effect will check if the current user has a multipleAddress, if yes, then open out the route for address selection.
   */
  useEffect(()=>{
    AppDispatch(openRouteAddressSelection(hasMultipleAddress === true));
  },[ hasMultipleAddress ]);

  const navigateToApplication = useCallback((singlePropertyObj:Properties)=>{
    let timeoutId: number;
    timeoutId = window.setTimeout(() => {
      const {address, hdb_ref} = {...singlePropertyObj};
      if(address && hdb_ref){
        setIsInit(false);
        window.location.href = "/transfer/application-coo";
      }
      else{
        setIsInit(false);
        alert("Oops, something wrong with the selected property.");
        navigate("/");
      }
    },1000);
   
    return () => {
      clearTimeout(timeoutId);
    }
  },[navigate])


  const processNewApplication = useCallback(async()=>{
    if(!isLoading){
      if (!smsInfo?.holding_type?.trim()) {
        await PolymerAxios(originalLoginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
          uinfin: originalLoginUser?.uinfin,
          message: `[ Polymer FE -> SingleProperty -> processNewApplication ]HDBref: ${singleProperty?.hdb_ref ?? "null"}, UIN: ${originalLoginUser?.uinfin} blocked: current holding type is blank (HDBCHVMTYR-1024 / 311).`
        });
        alert("An error occurred. Please try again later.");
        return;
      }

      let singlePropertyObj = new Properties(singleProperty);
      singlePropertyObj.decryptOwnersOccupiersAdditionalRoles();

      await AppDispatch(updateApplicationStartFormDataThunk({data:new ApplicationStart({ ...startApplicationFormData, has_outstanding_loan: hasOutstandingFees, selected_hdb_property: { ...singlePropertyObj, ...smsInfo } })}))
      
      setIsInit(true);
      
      let timeoutId: number;
      timeoutId = window.setTimeout(() => {
        navigateToApplication(singlePropertyObj);
      },3000);
     
      return () => {
        clearTimeout(timeoutId);
      }
    }
    else{
      console.log("HDB property info is running...");
    }
  },[AppDispatch, hasOutstandingFees, isLoading, navigateToApplication, originalLoginUser?.uinfin, singleProperty, singpassToken, smsInfo, startApplicationFormData])


  const handleContinueDraftApplication = useCallback(()=>{
    if(activeApplications?.length > 0 && activeApplications[0].application_status !== "CLOSED"){
      const url = `/application-coo?application_id=${activeApplications[0].application_id}`;
      toPath(url);    
    }
    else{
      processNewApplication();
    }
  },[activeApplications, processNewApplication, toPath])

  const processValidateNewApplication = useCallback(()=>{
    if(hasMultipleAddress === false){
      const findBb13Application = existingBb13Applications.find(item => item.hdb_ref.toLowerCase() === singleProperty?.hdb_ref.toLowerCase());
      if(findBb13Application && !config.byPassBB13){
          window.location.href = findBb13Application.link;
          return;
      }

      if(activeApplications?.length > 0){
        //1) if when only single address, then has draft, then show prompt
        //2) else when has multiple address, go to property selection page.
        //3) else create a new application
        AppDispatch(openRouteStartCooApplication(true));
        if(document.location.origin !== "https://services3.hdb.gov.sg" && document.location.origin !== "https://services3-stg.hdb.gov.sg"){
          setContinueDraftConfirmation(true);
          return;
        }
        const draftStages = [
          "SAVE_DRAFT",
          "SUBMIT_COMPLETE",
          "GATHER_CONSENT_COMPLETE",
          "PENDING_PAYMENT"
        ]
        if(draftStages.includes(activeApplications[0].application_status) || config.allowMultipleApplicationDebug){
          setContinueDraftConfirmation(true);
        }else{
          handleContinueDraftApplication();
        }
      }else{
        processNewApplication();
      }
    }
    else{
      processNewApplication();
    }
  },[AppDispatch, activeApplications, hasMultipleAddress, processNewApplication, existingBb13Applications, singleProperty, handleContinueDraftApplication])
  
  
  const checkIsEstateActionCodeExist = useMemo(()=>{
    if(config.bypassEstateActionCode) {
      return false;
    }
    const Estate_Action_Code_Enum = ["RS", "OT", "ME", "PT", "AJ", "RP", "SU", "SB", "CI", "SE"];
    
    if(smsInfo && Estate_Action_Code_Enum.includes(smsInfo?.financing_info?.estate_action_code)){
      return true;
    }
    else{
      return false;
    }
    
  },[smsInfo])

  const isSERSpostalCodeType1 = useMemo((): boolean => {
    const postalCode = singleProperty?.address?.split(" ")?.slice(-1)[0] ?? "";
    const SERS_POSTAL_CODES_1 = [ // Blks 562-565 Ang Mo Kio Ave 3
      "560562", "560563", "560564", "560565",
    ]
    return SERS_POSTAL_CODES_1.includes(postalCode) && isR2_151_Block_enabled;
  }, [singleProperty?.hdb_ref, singleProperty?.address])

  const isSERSpostalCodeType2 = useMemo((): boolean => {
    const postalCode = singleProperty?.address?.split(" ")?.slice(-1)[0] ?? "";
    const SERS_POSTAL_CODES_2 = [ // Blks 212-218 Marsiling Crescent/Lane
      "730212", "730213", "730214", "730215", "730216", "730217", "730218",
    ]
    return SERS_POSTAL_CODES_2.includes(postalCode) && isR2_151_Block_enabled;
  }, [singleProperty?.hdb_ref, singleProperty?.address])

  const isRdbStatesReady = useMemo(() => {
      return isIncluded !== undefined && (singleProperty !== undefined || hasMultipleAddress !== undefined || noProperty !== undefined);
  }, [singleProperty, hasMultipleAddress, isIncluded, noProperty])
  const isApiLoading = useMemo(() => {
      return (isLoading || isRdbLoading || !isRdbStatesReady) && !isRdbError;
  }, [isLoading, isRdbLoading, isRdbStatesReady, isRdbError])

  const handleApplicationCooForm = useCallback( async () => {
    if(isApiLoading) {
      setHasClickInitiateButtonWhenApiLoading(true);
      return;
    }

    if(isError || isRdbError) {
      await PolymerAxios(originalLoginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
        uinfin: originalLoginUser?.uinfin,
        message: `[ Polymer FE -> SingleProperty ->handleApplicationCooForm ]HDBref: ${singleProperty?.hdb_ref?singleProperty?.hdb_ref:"null"}, UIN: ${originalLoginUser?.uinfin} is unable to create a new application due to Error ${isError}`
      });
      alert("An error occurred. Please try again later.");
    }
    else if(noProperty){
      await PolymerAxios(originalLoginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
        uinfin: originalLoginUser?.uinfin,
        message: `[ Polymer FE -> SingleProperty  -> handleApplicationCooForm ]HDBref: ${singleProperty?.hdb_ref?singleProperty?.hdb_ref:"null"}, UIN: ${originalLoginUser?.uinfin} is unable to create a new application due to noProperty.`
      });
      alert("There is no property is registered under this applicant.");
    }
    else if (checkIsEstateActionCodeExist || (!hasMultipleAddress && (mamsEligibilityData === false))) {
      setIsShowingOngoingTransactionModal(true);
      await PolymerAxios(originalLoginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
        uinfin: originalLoginUser?.uinfin,
        message: `[ Polymer FE -> SingleProperty  -> handleApplicationCooForm ]HDBref: ${singleProperty?.hdb_ref?singleProperty?.hdb_ref:"null"}, UIN: ${originalLoginUser?.uinfin} is unable to create a new application due to OngoingTransaction.`
      });
    }
    else if(!isIncluded && isError === false){
      setOnlyExistingPop(true);
      await PolymerAxios(originalLoginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
        uinfin: originalLoginUser?.uinfin,
        message: `[ Polymer FE -> SingleProperty  -> handleApplicationCooForm ]HDBref: ${singleProperty?.hdb_ref?singleProperty?.hdb_ref:"null"}, UIN: ${originalLoginUser?.uinfin} is unable to create a new application due to NotExistingOwner.`
      });
    }
    else if(hasInitiatedApplication === true && !config.allowMultipleApplicationDebug) {
      setHasApplicationInitiatedModal(true);
      await PolymerAxios(originalLoginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
        uinfin: originalLoginUser?.uinfin,
        message: `[ Polymer FE -> SingleProperty  -> handleApplicationCooForm ]HDBref: ${singleProperty?.hdb_ref?singleProperty?.hdb_ref:"null"}, UIN: ${originalLoginUser?.uinfin} is unable to create a new application due to HasApplicationInitiated.`
      });
    }
    else if(hasOutstandingFees === true) {
      setHasOutstandingFeesModal(true);
      await PolymerAxios(originalLoginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
        uinfin: originalLoginUser?.uinfin,
        message: `[ Polymer FE -> SingleProperty  -> handleApplicationCooForm ]HDBref: ${singleProperty?.hdb_ref?singleProperty?.hdb_ref:"null"}, UIN: ${originalLoginUser?.uinfin} is unable to create a new application due to HasOutstandingFees.`
      });
    }
    else if(isSERSpostalCodeType1 === true) {
      setHasSERSPostalCodeType1Modal(true);
      await PolymerAxios(originalLoginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
        uinfin: originalLoginUser?.uinfin,
        message: `[ Polymer FE -> SingleProperty  -> handleApplicationCooForm ]HDBref: ${singleProperty?.hdb_ref?singleProperty?.hdb_ref:"null"}, UIN: ${originalLoginUser?.uinfin} is blocked from creating or access application flow due to the announcement of SERS (R2-151) [Blks 562-565 Ang Mo Kio Ave 3].`
      });
    }
    else if(isSERSpostalCodeType2 === true) {
      setHasSERSPostalCodeType2Modal(true);
      await PolymerAxios(originalLoginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
        uinfin: originalLoginUser?.uinfin,
        message: `[ Polymer FE -> SingleProperty  -> handleApplicationCooForm ]HDBref: ${singleProperty?.hdb_ref?singleProperty?.hdb_ref:"null"}, UIN: ${originalLoginUser?.uinfin} is blocked from creating or access application flow due to the announcement of SERS (R2-151) [Blks 212-218 Marsiling Crescent/Lane].`
      });
    }
    else if(isTopupGrantRequired === true){
      setHasTUGEligibilityModal(true);
    }
    else if(hasMultipleAddress){
      navigate("/application-coo/property-selection");
      return;
    }
    else{
      processValidateNewApplication();
    }
    
  },[checkIsEstateActionCodeExist, isError, isIncluded, noProperty, hasOutstandingFees, mamsEligibilityData, hasInitiatedApplication, hasMultipleAddress, toPath, processValidateNewApplication, isApiLoading, isTopupGrantRequired, isSERSpostalCodeType1, isSERSpostalCodeType2, originalLoginUser?.uinfin, singpassToken, singleProperty?.hdb_ref]);

  const handleEstimatedFees = () => {
    toPath("/estimate-fees")
  }

  useEffect(() => {
    AppDispatch(setActiveApplications(activeApplications));
  }, [AppDispatch, activeApplications])


  const getDraftApplicationDate = useMemo(()=>{
    if(activeApplications?.length > 0 && activeApplications[0]?.application_create_date){
       return Helpers.formatDate(activeApplications[0].application_create_date);
    }else{
      return '-';
    }

  },[activeApplications])

  const removeApplication = useCallback(async () => {
    const draftStages = [
      "SAVE_DRAFT",
      "SUBMIT_COMPLETE",
      "GATHER_CONSENT_COMPLETE",
      "PENDING_PAYMENT"
    ]
    if(activeApplications?.length > 0 && draftStages.includes(activeApplications[0].application_status)){
      try {
        await PolymerAxios(originalLoginUser?.uinfin ?? "", singpassToken)
          .post(`${API_ApplicationRemove}/${activeApplications[0].application_id}`)
          .then((res) => res.data);
      } catch (error) {
        console.log(error);
      }
    }
  }, [singpassToken, activeApplications, originalLoginUser]);


  const handleContinueDraftButton = useCallback(() => {
    setContinueDraftConfirmation(false);
    handleContinueDraftApplication();
  },[handleContinueDraftApplication])

  const handleCreateNewApplicationButton = useCallback(() => {
    removeApplication();
    processNewApplication();
    setContinueDraftConfirmation(false);
  },[processNewApplication, removeApplication])


  const handleHasOutstandingLoanPopUp = useCallback(()=>{
    setHasOutstandingFeesModal((prev) => !prev)
    processValidateNewApplication();
  },[processValidateNewApplication])

  const closeContinueDraftConfirmationModal = useCallback(() => {
    setContinueDraftConfirmation(false);
  }, [])

  const closeOutstandingFeeModal = useCallback(() => {
    setHasOutstandingFeesModal(false);
  }, [])

  const closeOnlyExistingPopModal = useCallback(() => {
    setOnlyExistingPop(false);
  }, [])
  
  const closeOngoingTransactionModal = useCallback(() => {
    setIsShowingOngoingTransactionModal(false);
  }, [setIsShowingOngoingTransactionModal])

  const closeHasInitiatedApplicationModal = useCallback(() => {
    setHasApplicationInitiatedModal(false);
  }, [])

  const closeTUGEligibilityModal = useCallback(() => {
    setHasTUGEligibilityModal(false);
  }, [])

  const closeSERSPostalCodeModal = useCallback(() => {
    setHasSERSPostalCodeType1Modal(false);
    setHasSERSPostalCodeType2Modal(false);
  }, [])

  const createDefinedHL4Application = useCallback( async (bypassPayment:boolean)=>{
  
      const draftResponse = await PolymerAxios("S3200048G", singpassToken).post(API_ApplicationSaveDraft, {
        "main_applicant_uinfin": "AAAAAAAAAAAAAAAAAAAAAOrLTTs4trP4ghBjFZL2Zng=",
        "hdb_ref": "83330365649",
        "confirm_attend_completion_person": "Yes",
        "has_private_property": false,
        "has_dispose_property": false,
        "flat_type": "05",
        "holding_type": "JT",
        "documents": [
          {
            "uuid": "3aadc763-5380-491c-a8a2-e6c7ad22f291",
            "code": "DC13",
            "required_option_checked": true,
            "file_name": "sample.pdf",
            "document_type": "pdf",
            "label": "Interim Judgement/ Order of Court or Decree stating the settlement of the matrimonial property",
            "key": "polymer/3aadc763-5380-491c-a8a2-e6c7ad22f291/pdf/sample_1709105012208.pdf",
            "uinfin": "",
            "id": null,
            "file_size": 3028
          },
          {
            "uuid": "78b5ea92-e7cc-4583-a349-6393aaa6cc3e",
            "code": "DC15",
            "required_option_checked": true,
            "file_name": "sample.pdf",
            "document_type": "pdf",
            "label": "Final Judgement",
            "key": "polymer/78b5ea92-e7cc-4583-a349-6393aaa6cc3e/pdf/sample_1709105014760.pdf",
            "uinfin": "",
            "id": null,
            "file_size": 3028
          },
          {
            "uuid": "1f7842ad-e45f-4582-b524-eb428b5bf6de",
            "code": "DC09",
            "required_option_checked": true,
            "file_name": "sample.pdf",
            "document_type": "pdf",
            "label": "Letter of Lawyer's Representation",
            "key": "polymer/1f7842ad-e45f-4582-b524-eb428b5bf6de/pdf/sample_1709105017265.pdf",
            "uinfin": "",
            "id": null,
            "file_size": 3028
          }
        ],
        "financing_info": {
          "current_loan_type": "H",
          "current_loan_amount": 0,
          "current_loan_date": "2023-10-17",
          "new_loan_type": "N"
        },
        "conveyancing": {
          "holding_type": "SO",
          "valuation": "",
          "estimated_market_value": "",
          "proposed_same_solicitor": false,
          "tenancy_in_common": [],
          "legal_representation": [
            {
              "solicitor_type": "private_solicitor",
              "owner_type": "current",
              "hdb_legal_term_condition": false,
              "conveyancing_same_solicitor": true,
              "solicitor": {
                "uen_of_law_firm": "12312312",
                "name_of_law_firm": "DECISION SCIENCE AGE",
                "email_of_solicitor": "ASK@DS1.COM"
              },
              "conveyancing_solicitor": {
                "uen_of_law_firm": "12312312",
                "name_of_law_firm": "DECISION SCIENCE AGE",
                "email_of_solicitor": "ASK@DS1.COM"
              }
            },
            {
              "solicitor_type": "conveyancing_private_solicitor",
              "owner_type": "proposed",
              "hdb_legal_term_condition": false,
              "conveyancing_same_solicitor": false,
              "solicitor": {
                "uen_of_law_firm": "",
                "name_of_law_firm": "",
                "email_of_solicitor": ""
              },
              "conveyancing_solicitor": {
                "uen_of_law_firm": "123123",
                "name_of_law_firm": "DECISION SCIENCE AGE",
                "email_of_solicitor": "123123@12.com"
              }
            }
          ]
        },
        "address": "Block 398, YISHUN RING RD, #08-1731, Singapore 760398",
        "change_ownership_reason": "COR1",
        "owners": [
          {
            "structure_status": "HSS2",
            "live_status": "A",
            "dod": "0001-01-01",
            "role_name": "Lessee",
            "children_care_and_control": null,
            "spr_obtained_date": "",
            "relationship_with_owner": "OT",
            "is_related": false,
            "structure_order": "L1",
            "gross_monthly_income": "123.00",
            "spouse": "",
            "uinfin": "AAAAAAAAAAAAAAAAAAAAAOrLTTs4trP4ghBjFZL2Zng=",
            "name": "Test Name 51",
            "sex": "M",
            "race": "C",
            "nationality": "SG",
            "residential_status": "C",
            "dob": "1953-02-01",
            "mobile_no": "AAAAAAAAAAAAAAAAAAAAACgMBTIupok+3Dln8p3yIfo=",
            "marital_status": "S",
            "email": "AAAAAAAAAAAAAAAAAAAAAMTDPum6ApuDOl8sy7VHiNNEV+2yX5Sd9S5UrC5tGesc5/qPiJI8Vkex9Xs756n9Qw==",
            "is_applicant": true
          },
          {
            "structure_status": "HSS1",
            "live_status": "A",
            "dod": "0001-01-01",
            "role_name": "Co-Lessee",
            "children_care_and_control": null,
            "spr_obtained_date": "",
            "relationship_with_owner": "OT",
            "is_related": false,
            "structure_order": "",
            "spouse": "",
            "uinfin": "AAAAAAAAAAAAAAAAAAAAAImA2a5loV4htgVvAENN0pY=",
            "name": "Rytqnqj Btw Yypqb",
            "sex": null,
            "race": null,
            "nationality": null,
            "residential_status": "C",
            "dob": "1987-11-17",
            "mobile_no": "",
            "marital_status": "S",
            "email": "",
            "is_applicant": false
          }
        ],
        "occupiers": [
          {
            "structure_status": "HSS1",
            "relationship_with_owner": "OT",
            "is_related": false,
            "spouse": "",
            "uinfin": "AAAAAAAAAAAAAAAAAAAAAEk24h/+UMhrifPGLwtBDPg=",
            "name": "Jqrqdq Jyliq",
            "sex": null,
            "race": null,
            "nationality": null,
            "residential_status": "C",
            "dob": "1964-04-13",
            "mobile_no": "",
            "marital_status": "M",
            "email": "",
            "spr_obtained_date": ""
          },
          {
            "structure_status": "HSS1",
            "relationship_with_owner": "OT",
            "is_related": false,
            "spouse": "",
            "uinfin": "AAAAAAAAAAAAAAAAAAAAAJO9PJwlrN+u1ey43emfP6c=",
            "name": "Pywd Fqdzil Bin Pywd Lptqn",
            "sex": null,
            "race": null,
            "nationality": null,
            "residential_status": "C",
            "dob": "2001-04-04",
            "mobile_no": "",
            "marital_status": "S",
            "email": "",
            "spr_obtained_date": ""
          }
        ],
        "change_in_marital_status": {
          "situation": "divorce",
          "have_final_judgement": true,
          "final_judgement_date": "2024-02-11",
          "date_of_marriage": "",
          "due_date_complete_application": "2024-02-04",
          "consideration_amount_stated": 3333,
          "cpf_refund_outgoing_owner": "full",
          "confirm_remove_owner_singpass_login": true
        },
        "change_in_financial_circumstances": {},
        "demise_of_current_owner": {},
        "renunciation": {},
        "moving_out": {},
        "outgoing_owner_represented": ""
      });
  
      if(draftResponse.status !== 200){
        alert("Draft got issue");
        return;
      }
  
      let applicationID = draftResponse.data.application_id;
  
      const response = await PolymerAxios("S3200048G", singpassToken).post(API_ApplicationSubmit, {
        "main_applicant_uinfin": "AAAAAAAAAAAAAAAAAAAAAOrLTTs4trP4ghBjFZL2Zng=",
        "hdb_ref": "83330365649",
        "confirm_attend_completion_person": "Yes",
        "has_private_property": false,
        "has_dispose_property": false,
        "flat_type": "05",
        "holding_type": "JT",
        "documents": [
          {
            "uuid": "3aadc763-5380-491c-a8a2-e6c7ad22f291",
            "code": "DC13",
            "required_option_checked": true,
            "file_name": "sample.pdf",
            "document_type": "pdf",
            "label": "Interim Judgement/ Order of Court or Decree stating the settlement of the matrimonial property",
            "key": "polymer/3aadc763-5380-491c-a8a2-e6c7ad22f291/pdf/sample_1709105012208.pdf",
            "uinfin": "",
            "id": null,
            "file_size": 3028
          },
          {
            "uuid": "78b5ea92-e7cc-4583-a349-6393aaa6cc3e",
            "code": "DC15",
            "required_option_checked": true,
            "file_name": "sample.pdf",
            "document_type": "pdf",
            "label": "Final Judgement",
            "key": "polymer/78b5ea92-e7cc-4583-a349-6393aaa6cc3e/pdf/sample_1709105014760.pdf",
            "uinfin": "",
            "id": null,
            "file_size": 3028
          },
          {
            "uuid": "1f7842ad-e45f-4582-b524-eb428b5bf6de",
            "code": "DC09",
            "required_option_checked": true,
            "file_name": "sample.pdf",
            "document_type": "pdf",
            "label": "Letter of Lawyer's Representation",
            "key": "polymer/1f7842ad-e45f-4582-b524-eb428b5bf6de/pdf/sample_1709105017265.pdf",
            "uinfin": "",
            "id": null,
            "file_size": 3028
          }
        ],
        "financing_info": {
          "current_loan_type": "H",
          "current_loan_amount": 0,
          "current_loan_date": "2023-10-17",
          "new_loan_type": "N"
        },
        "conveyancing": {
          "holding_type": "SO",
          "valuation": "",
          "estimated_market_value": "",
          "proposed_same_solicitor": false,
          "tenancy_in_common": [],
          "legal_representation": [
            {
              "solicitor_type": "private_solicitor",
              "owner_type": "current",
              "hdb_legal_term_condition": false,
              "conveyancing_same_solicitor": true,
              "solicitor": {
                "uen_of_law_firm": "12312312",
                "name_of_law_firm": "DECISION SCIENCE AGE",
                "email_of_solicitor": "ASK@DS1.COM"
              },
              "conveyancing_solicitor": {
                "uen_of_law_firm": "12312312",
                "name_of_law_firm": "DECISION SCIENCE AGE",
                "email_of_solicitor": "ASK@DS1.COM"
              }
            },
            {
              "solicitor_type": "conveyancing_private_solicitor",
              "owner_type": "proposed",
              "hdb_legal_term_condition": false,
              "conveyancing_same_solicitor": false,
              "solicitor": {
                "uen_of_law_firm": "",
                "name_of_law_firm": "",
                "email_of_solicitor": ""
              },
              "conveyancing_solicitor": {
                "uen_of_law_firm": "123123",
                "name_of_law_firm": "DECISION SCIENCE AGE",
                "email_of_solicitor": "123123@12.com"
              }
            }
          ]
        },
        "address": "Block 398, YISHUN RING RD, #08-1731, Singapore 760398",
        "change_ownership_reason": "COR1",
        "owners": [
          {
            "structure_status": "HSS2",
            "live_status": "A",
            "dod": "0001-01-01",
            "role_name": "Lessee",
            "children_care_and_control": null,
            "spr_obtained_date": "",
            "relationship_with_owner": "OT",
            "is_related": false,
            "structure_order": "L1",
            "gross_monthly_income": "123.00",
            "spouse": "",
            "uinfin": "AAAAAAAAAAAAAAAAAAAAAOrLTTs4trP4ghBjFZL2Zng=",
            "name": "Test Name 51",
            "sex": "M",
            "race": "C",
            "nationality": "SG",
            "residential_status": "C",
            "dob": "1953-02-01",
            "mobile_no": "AAAAAAAAAAAAAAAAAAAAACgMBTIupok+3Dln8p3yIfo=",
            "marital_status": "S",
            "email": "AAAAAAAAAAAAAAAAAAAAAMTDPum6ApuDOl8sy7VHiNNEV+2yX5Sd9S5UrC5tGesc5/qPiJI8Vkex9Xs756n9Qw==",
            "is_applicant": true
          },
          {
            "structure_status": "HSS1",
            "live_status": "A",
            "dod": "0001-01-01",
            "role_name": "Co-Lessee",
            "children_care_and_control": null,
            "spr_obtained_date": "",
            "relationship_with_owner": "OT",
            "is_related": false,
            "structure_order": "",
            "spouse": "",
            "uinfin": "AAAAAAAAAAAAAAAAAAAAAImA2a5loV4htgVvAENN0pY=",
            "name": "Rytqnqj Btw Yypqb",
            "sex": null,
            "race": null,
            "nationality": null,
            "residential_status": "C",
            "dob": "1987-11-17",
            "mobile_no": "",
            "marital_status": "S",
            "email": "",
            "is_applicant": false
          }
        ],
        "occupiers": [
          {
            "structure_status": "HSS1",
            "relationship_with_owner": "OT",
            "is_related": false,
            "spouse": "",
            "uinfin": "AAAAAAAAAAAAAAAAAAAAAEk24h/+UMhrifPGLwtBDPg=",
            "name": "Jqrqdq Jyliq",
            "sex": null,
            "race": null,
            "nationality": null,
            "residential_status": "C",
            "dob": "1964-04-13",
            "mobile_no": "",
            "marital_status": "M",
            "email": "",
            "spr_obtained_date": ""
          },
          {
            "structure_status": "HSS1",
            "relationship_with_owner": "OT",
            "is_related": false,
            "spouse": "",
            "uinfin": "AAAAAAAAAAAAAAAAAAAAAJO9PJwlrN+u1ey43emfP6c=",
            "name": "Pywd Fqdzil Bin Pywd Lptqn",
            "sex": null,
            "race": null,
            "nationality": null,
            "residential_status": "C",
            "dob": "2001-04-04",
            "mobile_no": "",
            "marital_status": "S",
            "email": "",
            "spr_obtained_date": ""
          }
        ],
        "change_in_marital_status": {
          "situation": "divorce",
          "have_final_judgement": true,
          "final_judgement_date": "2024-02-11",
          "date_of_marriage": "",
          "due_date_complete_application": "2024-02-04",
          "consideration_amount_stated": 3333,
          "cpf_refund_outgoing_owner": "full",
          "confirm_remove_owner_singpass_login": true
        },
        "change_in_financial_circumstances": {},
        "demise_of_current_owner": {},
        "renunciation": {},
        "moving_out": {},
        "outgoing_owner_represented": "",
        "application_id": applicationID
      });
  
      if (response.status === 200) {
  
        if(applicationID){
  
          console.log("applicationID",applicationID);
          let mainApplicantGiveConsentData = {
            "documents": [],
            "financing_info": {
              "current_loan_type": "H",
              "current_loan_amount": 0,
              "current_loan_date": "2023-10-17",
              "new_loan_type": "N"
            },
            "conveyancing": {
              "holding_type": "SO",
              "valuation": "",
              "estimated_market_value": "",
              "proposed_same_solicitor": false,
              "tenancy_in_common": [],
              "legal_representation": [
                {
                  "solicitor_type": "private_solicitor",
                  "owner_type": "current",
                  "hdb_legal_term_condition": false,
                  "conveyancing_same_solicitor": true,
                  "solicitor": {
                    "uen_of_law_firm": "12312312",
                    "name_of_law_firm": "DECISION SCIENCE AGE",
                    "email_of_solicitor": "ASK@DS1.COM"
                  },
                  "conveyancing_solicitor": {
                    "uen_of_law_firm": "12312312",
                    "name_of_law_firm": "DECISION SCIENCE AGE",
                    "email_of_solicitor": "ASK@DS1.COM"
                  }
                },
                {
                  "solicitor_type": "conveyancing_private_solicitor",
                  "owner_type": "proposed",
                  "hdb_legal_term_condition": false,
                  "conveyancing_same_solicitor": false,
                  "solicitor": {
                    "uen_of_law_firm": "",
                    "name_of_law_firm": "",
                    "email_of_solicitor": ""
                  },
                  "conveyancing_solicitor": {
                    "uen_of_law_firm": "123123",
                    "name_of_law_firm": "DECISION SCIENCE AGE",
                    "email_of_solicitor": "123123@12.com"
                  }
                }
              ]
            },
            "outgoing_owner_represented": "",
            "application_uuid": applicationID,
            "give_consent": true,
            "owner": {
              "relationship_with_owner": "",
              "uinfin": "AAAAAAAAAAAAAAAAAAAAAOrLTTs4trP4ghBjFZL2Zng=",
              "mobile_no": "AAAAAAAAAAAAAAAAAAAAACgMBTIupok+3Dln8p3yIfo=",
              "marital_status": "S",
              "email": "AAAAAAAAAAAAAAAAAAAAAMTDPum6ApuDOl8sy7VHiNNEV+2yX5Sd9S5UrC5tGesc5/qPiJI8Vkex9Xs756n9Qw==",
              "sex": "M",
              "race": "C",
              "nationality": "SG",
              "spouse": "",
              "gross_monthly_income": "123.00"
            }
          }
  
          let secondApplicantGiveConsentdata = {
            "documents": [],
            "financing_info": {
              "current_loan_type": "H",
              "current_loan_amount": 0,
              "current_loan_date": "2023-10-17",
              "new_loan_type": "N"
            },
            "conveyancing": {
              "holding_type": "SO",
              "valuation": "",
              "estimated_market_value": "",
              "proposed_same_solicitor": false,
              "tenancy_in_common": [],
              "legal_representation": [
                {
                  "solicitor_type": "private_solicitor",
                  "owner_type": "current",
                  "hdb_legal_term_condition": false,
                  "conveyancing_same_solicitor": true,
                  "solicitor": {
                    "uen_of_law_firm": "12312312",
                    "name_of_law_firm": "DECISION SCIENCE AGE",
                    "email_of_solicitor": "ASK@DS1.COM"
                  },
                  "conveyancing_solicitor": {
                    "uen_of_law_firm": "12312312",
                    "name_of_law_firm": "DECISION SCIENCE AGE",
                    "email_of_solicitor": "ASK@DS1.COM"
                  }
                },
                {
                  "solicitor_type": "conveyancing_private_solicitor",
                  "owner_type": "proposed",
                  "hdb_legal_term_condition": false,
                  "conveyancing_same_solicitor": false,
                  "solicitor": {
                    "uen_of_law_firm": "",
                    "name_of_law_firm": "",
                    "email_of_solicitor": ""
                  },
                  "conveyancing_solicitor": {
                    "uen_of_law_firm": "123123",
                    "name_of_law_firm": "DECISION SCIENCE AGE",
                    "email_of_solicitor": "123123@12.com"
                  }
                }
              ]
            },
            "outgoing_owner_represented": "",
            "application_uuid": applicationID,
            "give_consent": true,
            "owner": {
              "relationship_with_owner": "",
              "uinfin": "",
              "mobile_no": "AAAAAAAAAAAAAAAAAAAAAJdB/s1KrGdzfqlW+fq7drc=",
              "marital_status": "",
              "email": "AAAAAAAAAAAAAAAAAAAAAI9ZdMAZ2ygZ3dUZjDTmEjqSFOz9xnrD3YdKsO4CLCao7PZJr8E46RfT060FGbDKcg==",
              "sex": null,
              "race": null,
              "nationality": null,
              "spouse": ""
            },
            "application_id": applicationID
          }
    
          await PolymerAxios("S3200048G", singpassToken).post(API_GiveConsent, mainApplicantGiveConsentData);
          await PolymerAxios("S9110787B", singpassToken).post(API_GiveConsent, secondApplicantGiveConsentdata);
  
  
          if(bypassPayment){
            let processPaymentBody = {
              application_uuid: applicationID,
            }
            await PolymerAxios("S3200048G", singpassToken).post(API_ApplicationProcessPayment, processPaymentBody);
  
            let applicationPaymentBody = {
              "application_uuid": applicationID,
              "payment_mode": "CR",
              "transaction_type": "admin"
            }
            const paymentResponse = await PolymerAxios("S3200048G", singpassToken).post(API_ApplicationPayment, applicationPaymentBody);
    
            let creditNotificationBody = {
              "systIdforPayment": "AC89598",
              "numTrnscn": 2,
              "totalAmt": 50.00,
              "ttcNum": paymentResponse?.data?.ttcNum, // must equal with paymentRequest ttcNum
              "hashNum": "HASH123",
              "transactionDate": moment().format('yyyy-MM-DD'),
              "transactionTime": moment().format('HH:mm:ss'),
              "details": [
                {
                  "bankReferenceNo": "REF123",
                  "receiptNum": "REC123",
                  "caseNum": "141104S0235",
                  "systID": "SYS123",
                  "amount": 45.87,
                  "rcptngCode": "0875C"
                },
                {
                  "bankReferenceNo": "REF123",
                  "receiptNum": "REC123",
                  "caseNum": "141104S0235",
                  "systID": "SYS123",
                  "amount": 4.13,
                  "rcptngCode": "6225B"
                }
              ]
            }
            const creditNotiResponse = await PolymerAxios("S3200048G", singpassToken).post(API_ApplicationCreditNotification, creditNotificationBody);
    
            if (creditNotiResponse.status === 200) {
              console.log(creditNotiResponse.data)
              alert(`${applicationID} - ${creditNotiResponse.data.httpMessage}`);
    
            }
            else{
              alert("Bypass Payment having issue!");
            }
          }
          else{
            alert(`${applicationID} - Application Created`);
          }
  
        }
        else {
          console.log("applicationID", applicationID);
          alert("No Application Created!");
        }
      }
      else{
        console.log("response.status",response.status);
        alert("No Application Created!");
      }
  
    },[singpassToken])
  
  useEffect(() => {
    if(hasClickInitiateButtonWhenApiLoading && !isApiLoading) {
      if(isError) {
        console.log("hit error prepress button")
        alert("An error occurred. Please try again later.");
        setHasClickInitiateButtonWhenApiLoading(false);
      } else {
        console.log('handlingApplicationCooFormAuto:', JSON.stringify({
          isApiLoading,
          isSmsLoading: isLoading,
          isRdbLoading,
          isRdbStatesReady,
          isRdbError,
          isIncluded,
          singleProperty,
          hasMultipleAddress,
          noProperty
        }))
        if((singleProperty !== undefined && smsInfo !== undefined) || hasMultipleAddress || noProperty){
          handleApplicationCooForm();
        }
      }
    }
  }, [isApiLoading, hasClickInitiateButtonWhenApiLoading, isError, singleProperty, smsInfo, hasMultipleAddress, noProperty])

  return (
      <ApplicationCooDashboardLayout>
        <p hidden aria-hidden>{process.env.NODE_ENV}</p>
        <div className='polymer-dashboard'>
          <div className='polymer-dashboard__greetings'>
            <p>Hello {loginUserSpcpName === "" ? originalLoginUser?.name : loginUserSpcpName}!</p>
          </div>
          {showApplicationCancelledAlert ? <P2Alert style={{marginTop: 32}}  variant={"success"} text={"Application for Change in Flat Ownership has been cancelled."}></P2Alert> : alertJSX}
          {valuationFeePendingApp && (
            <div className="mt-4">
              <P2Alert
                variant="warning"
                title="Make valuation fee payment"
                text={<span>Payment for the valuation fee is required by HDB. <a href="#" className="polymer-text-links" onClick={(e) => { e.preventDefault(); AppDispatch(openRouteStageD(true)); navigate(`/application-coo/stage-d/hdb-review?application_id=${valuationFeePendingApp.applicationUuid}`); }}>Make payment.</a></span>}
              />
            </div>
          )}
          <Separator style={{marginTop:53, marginBottom:53}} variant="dashed" title='e-Services'/>
          <div className='polymer-dashboard__eservices'>
            <P2EServiceCard onClick={handleApplicationCooForm} title={<p>Change in Flat Ownership</p>} icon={<FlatIcon size={isMobile ? 58 : 80}/>} style={isMobile ? {minWidth: 160, width: 160, minHeight: 208} : {}}/>
            {config.showEstimateFees ? <P2EServiceCard onClick={handleEstimatedFees} title={<p>Estimate Fees for Change in Flat Ownership</p>} icon={<FlatIcon size={isMobile ? 58 : 80}/>} style={isMobile ? {minWidth: 160, width: 160, minHeight: 208} : {}}/> : null }
            {/* <P2EServiceCard title={"Conversion Scheme"}/>
            <P2EServiceCard title={"Change in Manner of Holding"}/> 
            <P2EServiceCard title={"Financial Planning Calculator"}/> */}
          </div>
          <p style={{display:"none"}}>Application Length - {ongoingApplications?.length}</p>
          {
            ongoingApplications && ongoingApplications.length > 0 && (
              <StatusTrackers>
                {ongoingApplications.slice(0,config.allowMultipleApplicationDebug ? 999 : 3).map((item, index) => {
                  const key = index;
                  const findBb13Application = existingBb13Applications?.find(e => e.hdb_ref === item.hdb_ref && e.status !== "X");
                  return(
                    <Fragment key={key}>
                      <TrackerItem debug={config.allowMultipleApplicationDebug} item={item} itemBB13={findBb13Application}/>
                    </Fragment>
                  )
                })}
                {ongoingApplications.length <= 2 && <TrackerItem />}
                {ongoingApplications.length === 1 && <TrackerItem />}
              </StatusTrackers>
            )
          }
          {
            bb13Applications && bb13Applications.length > 0 && (
              <StatusTrackers>
                {
                  bb13Applications.slice(0,config.allowMultipleApplicationDebug ? 999 : 3).map((item, index) => {
                    const key = index;
                    return(
                      <Fragment key={key}>
                        <TrackerItem debug={config.allowMultipleApplicationDebug} itemBB13={item} />
                      </Fragment>
                    )
                  })
                }
                {bb13Applications.length <= 2 && <TrackerItem />}
                {bb13Applications.length === 1 && <TrackerItem />}
              </StatusTrackers>
            )
          }

          {/*<Separator style={{marginTop:53, marginBottom:53}} variant="dashed" title='Draft Application'/>

          <div className='polymer-status-tracker__content'>
            <div className={`polymer-tracker-item polymer-tracker-item__wrapper`}>
              <div className='polymer-tracker-item__content'>
                <>
                  <p className='polymer-tracker-item__content-title'>Change in Flat Ownership:</p>
                  <p className='polymer-tracker-item__content-description'>Blk 772, #16-145, Bedok Reservoir View, Singapore 319074</p>
                </>
                  <p className='polymer-tracker-item__content-description'>Date of Application: 15 Dec 2022</p>
              </div>
            </div>
            
               <div className={`polymer-tracker-item polymer-tracker-item__wrapper`}>
              <div className='polymer-tracker-item__content'>
                <>
                  <p className='polymer-tracker-item__content-title'>Change in Flat Ownership:</p>
                  <p className='polymer-tracker-item__content-description'>Blk 772, #16-145, Bedok Reservoir View, Singapore 319074</p>
                </>
                  <p className='polymer-tracker-item__content-description'>Date of Application: 15 Dec 2022</p>
              </div>
            </div>
            
               <div className={`polymer-tracker-item polymer-tracker-item__wrapper`}>
              <div className='polymer-tracker-item__content'>
                <>
                  <p className='polymer-tracker-item__content-title'>Change in Flat Ownership:</p>
                  <p className='polymer-tracker-item__content-description'>Blk 772, #16-145, Bedok Reservoir View, Singapore 319074</p>
                </>
                  <p className='polymer-tracker-item__content-description'>Date of Application: 15 Dec 2022</p>
              </div>
            </div>
          </div> */}


          {/* <Separator style={{marginTop:53, marginBottom:53}} variant="dashed" title='FAQs'/>
          <div style={{ maxWidth: "853px", margin: "0 auto" }}>
            <div style={{margin:"20px 0px"}}>
              <P2Accordion defaultOpen={false} title={<p style={{fontWeight:500, fontSize:18, margin: 0 }}>What is Change in Flat Ownership</p>}>
                <div>The EASE programme is part of the Home Improvement Programme (HIP), offered from July 2012. It is also offered separately under EASE (Direct Application). Improvement items installed in your flat through EASE can make it more elderly-friendly, and improve mobility and comfort for elderly residents.</div>
              </P2Accordion>
            </div>
            <div style={{margin:"20px 0px"}}>
              <P2Accordion defaultOpen={false} title={<p style={{fontWeight:500, fontSize:18, margin: 0 }}>How do I change the ownership of my flat?</p>}>
              <div>A change in flat ownership is a conveyancing procedure, similar to that of purchasing an HDB flat. All current and proposed owners must be aware of and give consent to the change in flat ownership.</div>
              <div>This legal process involves the preparation of financial and legal documents. The process typically takes about 4 months, after all applicants have provided their confirmation to proceed with the ownership change and submitted all required documents. A longer processing time may occur for complex cases, such as those which requires lawyer's clarification relating to Court Orders.</div>
              </P2Accordion>
            </div>
            <div style={{margin:"20px 0px"}}>
              <P2Accordion defaultOpen={false} title={<p style={{fontWeight:500, fontSize:18, margin: 0 }}>Who can initiate a change in flat ownership?</p>}>
                <div>Current flat owners may apply to change their flat ownership to include immediate family members who meet all eligibility conditions. If there is more than 1 proposed owner, they would need to decide on the manner of holding the flat upon the ownership change, whether by joint-tenancy, or tenancy-in-common.  A maximum of 4 flat owners can be allowed for each flat. </div>
              </P2Accordion>
            </div>
            <div style={{margin:"20px 0px"}}>
              <P2Accordion defaultOpen={false} title={<p style={{fontWeight:500, fontSize:18, margin: 0 }}>Eligibility</p>}>
                <div>Proposed owners will have to meet these eligibility conditions.</div>
              </P2Accordion>
            </div>
          </div> */}


        </div>
        <P2Modal 
          isOpen={isInit || (hasClickInitiateButtonWhenApiLoading && isApiLoading)}
          children={<LottieLoader/>}
        />
        <P2Modal
          isOpen={continueDraftConfirmation}
          onCloseModal={closeContinueDraftConfirmationModal}
          title={`Create new application`}
          primaryButtonText="No, continue current application"
          secondaryButtonText="Yes, create new application"
          primaryButtonFunction={handleContinueDraftButton}
          secondaryButtonFunction={handleCreateNewApplicationButton}
          children={<p>A draft application was initiated and saved on {getDraftApplicationDate}. Do you want to create a new application?</p>}
        />
        <P2Modal
          isOpen={hasOutstandingFeesModal}
          onCloseModal={closeOutstandingFeeModal}
          variant="default"
          title={`You having outstanding fee(s)`}
          primaryButtonText="Acknowledge"
          primaryButtonFunction={handleHasOutstandingLoanPopUp}
          children={<p>You have outstanding fees with HDB. Please make the necessary payments before initiating a change in flat ownership.</p>}
        />
        <P2Modal
          isOpen={onlyExistingPop}
          onCloseModal={closeOnlyExistingPopModal}
          variant="default"
          title={`You are not eligible to proceed.`} 
          primaryButtonText="Back"
          primaryButtonFunction={() => setOnlyExistingPop(false)}
          children={<><p>Only existing flat owner(s) can submit a request for the change in flat ownership. Find out more about requesting for a <a className="polymer-text-links" href="https://www.hdb.gov.sg/cs/infoweb/residential/living-in-an-hdb-flat/changing-owners-occupiers/change-in-ownership/change-in-flat-ownership">change in flat ownership</a>.</p></>}
        />
        <P2Modal
          isOpen={isShowingOngoingTransactionModal}
          onCloseModal={closeOngoingTransactionModal}
          variant="default"
          title={`You cannot start a new application.`} 
          children={<><p>You cannot submit a request for the change in flat ownership because another transaction for the flat is currently in progress.</p></>}
        />
        <P2Modal
          isOpen={hasApplicationInitiatedModal}
          onCloseModal={closeHasInitiatedApplicationModal}
          variant="default"
          title={`This property has been initiated by other applicant`}
          primaryButtonText="Acknowledge"
          primaryButtonFunction={closeHasInitiatedApplicationModal}
          children={<p>You cannot submit a change of flat ownership application because another applicant has already initiated a request for this property.</p>}
        />
        <P2Modal
          isOpen={hasTUGEligibilityModal}
          // onCloseModal={closeHasInitiatedApplicationModal}
          variant="default"
          title={`You cannot start a new application`}
          primaryButtonText="Back"
          primaryButtonFunction={closeTUGEligibilityModal}
          children={<p>There is an ongoing top-up grant application. Please complete the top-up application process before submitting a change in flat ownership application. Thank you.</p>}
        />
        <P2Modal
          isOpen={hasSERSPostalCodeType1Modal}
          onCloseModal={closeSERSPostalCodeModal}
          variant="default"
          title={`You cannot start a new application`}
          primaryButtonText="Back"
          primaryButtonFunction={closeSERSPostalCodeModal}
          children={<p>Submission of application is not allowed. Please approach our Ang Mo Kio Branch for further assistance.</p>}
        />
        <P2Modal
          isOpen={hasSERSPostalCodeType2Modal}
          onCloseModal={closeSERSPostalCodeModal}
          variant="default"
          title={`You cannot start a new application`}
          primaryButtonText="Back"
          primaryButtonFunction={closeSERSPostalCodeModal}
          children={<p>Submission of application is not allowed. Please approach our Woodlands Branch for further assistance.</p>}
        />
      </ApplicationCooDashboardLayout>
  );
}

export default Root